/* Guitar Lyrics Generator
   Requires (load before this file):
     opentype.js  https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js
     paper-core   https://cdn.jsdelivr.net/npm/paper@0.12.17/dist/paper-core.min.js
*/
(function () {
  'use strict';

  function initGuitarLyrics() {
    if (!document.getElementById('plaque-app')) return;   // not on this page
    if (document.getElementById('plaque-app').dataset.ready) return;  // already booted
    document.getElementById('plaque-app').dataset.ready = '1';

    const SHAPE_D="M518.5,502.3l-1,0c-33.7,0-61-14.9-81.2-44.4l-126,0.6c0,10.3,0,54.7,0,54.7c0,11.2-6.4,17.6-17.6,17.6l-14.7,0 c-3.8,0-7.6,0-11.5,0c-10.2,0-16.7-6.6-16.8-16.7c0-10.6,0-21.2,0-31.8l0-157.1c0-9.9-0.1-20.4,0-32.3c0-9.9,6.7-16.6,16.6-16.7 c6.7,0,13.4,0,20.2,0l6.8,0c10.3,0,17,6.7,17,17c0,0,0,45.6,0,55.5c42.1,0,84.7,0.4,126,0.8c20.1-29.6,47.5-44.7,81.4-44.7l0.9,0 c24.8,0.2,45.9,8.4,63.2,24.6h143.8c-5.7-33.2-17.4-60-34-77.7c-16.5-17.5-34.6-26.6-62.4-31.4c-19.8-3.3-32.4-2.7-70.2,3.9 c-20,3.4-22.9,3.7-41.5,3.6c-18,0-21.3-0.3-33-2.7c-29.5-6.3-47.7-12.9-97.1-35.2c-61.5-27.8-85.8-36.2-117.7-40.4 c-9.2-1.3-38-1.3-45.2,0c-36.5,6.3-60.7,18.2-83.6,40.9c-21.7,21.4-37.2,47.6-48.8,82c-8.5,25.1-12.9,46.2-17.3,82 c-1.8,14.3-1.7,75.7,0,90.5c3.7,30.6,9.9,59.8,17.2,81.5c27.5,80.8,81.6,124,155.2,124c38,0,68.1-8.8,136.8-40 c67-30.5,99-40,133.8-40c13.8,0,19.4,0.7,49.2,5.7c19,3.3,23.5,3.7,39,3.8c19.3,0,27.1-1.2,44-6.7c17.4-5.6,28.4-12.4,40.1-24.5 c14.8-15.1,24.5-33.9,31.4-60.9c0.8-3,1.6-6.6,2.4-10.4H582.4C564.9,493.8,543.6,502.1,518.5,502.3z";
    const GP=["M531.6,314c-0.6-3.8-1.3-7.5-2-11.6c2.7,0,535.8,0.1,539.3,0.1v-3.8c-3.3,0-536.3,0-538.8-0.1c-0.7,0-1.4,0.1-2.1-0.5 c-1.1-3.3-2.3-6.8-4-10.5c4.1,0.1,539.2,0.2,545,0.3v-3.9c-6.6-0.1-542.3-0.2-546.8-0.3c-16.8-28.7-40.8-45.9-74.6-46.2 c-33.8-0.3-58.4,16.3-75.7,44.7c-48-0.4-96.1-0.9-144.2-0.8c-0.5-1.8-0.3-3.3-0.3-4.9c0-20.9,0-41.7,0-62.6c0-3.6-1.4-5-5-5 c-9,0-17.9,0-26.9,0c-3.3,0-4.6,1.4-4.6,4.7c0,10.7,0,21.5,0,32.2c0,3.2,1.3,4.5,4.5,4.5c4.7,0,9.4,0,14.1,0 c7.2,0,12.6,5.4,12.8,12.6c0.1,4.1,0,8.2,0,12.3c0,2,0.3,4-0.3,6.1c-2.2,0-4.3,0.3-6.5-0.1c0-3,0-5.8,0-8.6c0-2.6-1-3.8-3-3.8 c-2,0-3,1.3-3,3.8c0,2.8,0,5.7,0,8.5c-0.9,0.1-1.4,0.2-2,0.2c-2.3,0-4.6,0-6.9,0c-2.5-3.5-4.8-4.5-7.6-3.5 c-2.3,0.8-3.8,2.9-3.8,5.6c0,2.7,1.5,4.8,4,5.6c2.7,0.9,5-0.2,7.5-3.6c2.8,0,5.7,0,8.6,0c0,4,0,7.8,0,11.9c-3,0-5.9,0-8.8,0 c-2.4-3.2-4.6-4.3-7.3-3.5c-2.3,0.7-3.9,2.9-3.9,5.5c-0.1,2.5,1.4,4.8,3.7,5.6c2.8,1,5-0.1,7.6-3.5c2.9,0,5.7,0,8.6,0 c0,4.4,0,8.5,0,12.9c-1.7,0-3.1,0-4.6,0c-1.5,0-2.9,0-4.2,0c-2.8-4-6-4.7-9.1-2.3c-2.6,2.1-2.8,6-0.5,8.5c2.8,2.9,6.1,2.1,9.8-2.2 c3,0,5.8,0,8.6,0c0,4.3,0,8.5,0,12.8c-3.1,0-6,0-8.8,0c-2.5-3.3-4.7-4.2-7.5-3.2c-2.3,0.8-3.8,3.1-3.7,5.6c0.1,2.6,1.6,4.6,4,5.4 c2.8,0.9,4.9-0.2,7.3-3.7c2.9,0,5.7,0,8.6,0c0,4,0,7.9,0,12c-3.1,0-6,0-8.8,0c-2.2-3.1-4.3-4.2-7-3.4c-2.4,0.7-4.1,2.8-4.2,5.3 c-0.1,2.7,1.3,5,3.7,5.9c2.7,1,4.9,0,7.9-3.8c2.7,0,5.6-0.2,8.4,0.2c0,4,0,7.7,0,11.7c-3,0-5.9,0-8.8,0c-2.4-3.2-4.5-4.2-7.1-3.4 c-2.5,0.8-4.1,3-4.1,5.8c0,2.6,1.3,4.6,3.6,5.4c3.2,1,5.4,0.1,7.8-3.6c2.9,0,5.7,0,8.8,0c0,3.2,0,6.3,0,9.4c0,0.8-0.1,1.6,0.3,2.3 c0.7,1.2,1.8,2,3.3,1.7c1.7-0.3,2.4-1.6,2.4-3.2c0-3.4,0-6.7,0-10.3c2.5,0.1,4.6-0.3,6.8,0.3c0,4,0,8,0,11.9c0,2.4,0.1,4.8-0.1,7.2 c-0.6,6.8-6,11.7-12.9,11.7c-4.6,0-9.1,0-13.7,0c-3.5,0-4.8,1.3-4.8,4.7c0,10.6,0,21.2,0,31.8c0,3.5,1.3,4.7,4.8,4.7 c8.7,0,17.5,0,26.2,0c4.5,0,5.6-1.1,5.6-5.6c0-21.3,0-42.5,0-63.8c0-0.9-0.2-1.8,0.3-2.9c48.1-0.2,96.3-0.5,144.2-0.7 c17.6,28.4,42.1,44.7,75.7,44.4c33.6-0.3,57.8-17.1,74.7-45.8c4.5-0.1,540.2-0.2,546.7-0.3v-3.9c-3.6,0-536.4,0.1-538.9,0.1 c-1.9,0-3.8,0-6.2,0c1.7-3.6,2.9-7,4.1-10.7c3.1,0,536.8,0,540.9-0.1v-4c-3.1,0-536.3,0-539.6,0c0.7-3.7,1.4-7.3,2.1-11.1 c2.2,0,534.7,0,537.5,0v-4.1c-2.6,0-534.9,0-536.9,0c0-4.3,0.4-8.4,0-12.7c2.1,0,534.4,0,537,0v-4.1c-1.6,0-533.2,0-534.6,0 C533.4,314.3,532.5,314.5,531.6,314z M215.5,285.4c2.2,0,4.3,0,6.5,0c0,3.9,0,7.7,0,11.8c-2.3,0.2-4.3,0.3-6.5,0 C215.5,293.2,215.5,289.4,215.5,285.4z M215.5,314.1c0-4.2,0-8.4,0-12.7c2.2,0,4.2,0,6.5,0c0,4.3,0,8.5,0,12.7 C219.8,314.1,217.8,314.1,215.5,314.1z M215.5,335.2c2.2-0.4,4.3-0.2,6.5-0.1c0,4.2,0,8,0,11.9c-2.2,0.5-4.3,0.3-6.5,0.2 C215.5,343.1,215.5,339.2,215.5,335.2z M222,362.9c-2.2,0.5-4.3,0.2-6.5,0.2c0-4,0-7.8,0-11.9c2.3-0.2,4.4-0.3,6.5,0.1 C222,355.2,222,359,222,362.9z M222.1,331c-2.1,0.3-4.2,0.2-6.5,0c0-4.3,0-8.4,0-12.8c2.3,0,4.4,0,6.5,0 C222.1,322.5,222.1,326.6,222.1,331z M522.9,314.2c-2.5,0-4.8,0-7.2,0c-0.9-3.8-1.8-7.7-2.8-11.8c2.6-0.3,5-0.1,7.6,0.1 C521.6,306.3,522.4,310.1,522.9,314.2z M382.1,350c-0.5-0.6-0.9-1.3-0.6-2.5c43.5,0,87,0,130.6,0c0.2,0.8-0.2,1.6-0.9,2.5 C468.3,350,425.3,350,382.1,350z M503.6,364.8c-37.8,0.2-75.4,1.1-113.1,0.8c-0.7-0.7-1.3-1.4-1.7-2.6c38.7-0.3,77.3-0.5,115.9-0.8 C504.9,363.5,504,364,503.6,364.8z M378.1,334.3c-0.5-1.1-0.5-1.1-0.4-2.5c45.8,0,91.7,0,137.7,0c0.2,1,0.1,1.6-0.3,2.5 C469.5,334.3,423.8,334.3,378.1,334.3z M511,298.6c0.7,1.2,1,1.9,1,2.6c-43.5,0-87,0-130.4,0c-0.4-1.3,0-2.1,0.4-2.6 C425.1,298.6,468.1,298.6,511,298.6z M389.3,285.3c0.3-1.4,0.3-1.4,1.4-2.7c37.4,0.1,75.1,0.7,112.7,1.2c0.7,0.9,1.3,1.5,1.4,2.8 C466.3,286.2,427.8,285.7,389.3,285.3z M515.1,314.8c0.4,0.9,0.5,1.6,0.2,2.5c-45.8,0-91.6,0-137.5,0c-0.5-0.8-0.3-1.6-0.1-2.5 C423.5,314.8,469.3,314.8,515.1,314.8z M519,298.3c-2.6,0-5,0-7.5,0c-1.9-3.4-3.1-7.2-5.4-10.7c2.9,0,5.5,0,8.3,0 C516.3,290.8,517.7,294.4,519,298.3z M445.6,246.3c28.8-0.4,50.5,13,66.6,37.2c-3.3,0-5.9,0-8.6,0c-14-18.8-32.5-29.5-56.1-29.7 c-23.6-0.2-42.4,9.9-57.2,28.4c-1.2,0-2.6,0-4,0c-1.3,0-2.6,0-4.5,0C397.5,259.5,418.4,246.8,445.6,246.3z M379.6,286.2 c2.7,0,5.2,0,8.1,0c-2.1,3.9-4.1,7.5-5.6,11.5c-2.6,0-5,0-7.7,0C375.6,293.5,377.6,289.8,379.6,286.2z M372.8,301.8 c2.4,0,4.8,0,7.6,0c-1.3,4.1-2.2,8-2.9,12.2c-2.3,0-4.7,0-7.2,0C370.5,309.8,371.6,305.9,372.8,301.8z M377.1,331.1 c-2.6,0-4.9,0-7.3,0c-0.4-4.3-0.8-8.4,0-12.7c2.3-0.5,4.5-0.2,7.1-0.2C376.7,322.5,376.7,326.7,377.1,331.1z M227.4,285.2 c47.5,0.3,94.8,0.5,142.6,0.8c-1.7,4.2-3.2,7.9-4.7,11.5c-46,0-91.9,0-137.9,0C227.4,293.3,227.4,289.4,227.4,285.2z M361.2,331 c-44.6,0-89.1,0-133.8,0c0-4.3,0-8.5,0-12.8c44.6,0,89.1,0,133.9,0C360.7,322.5,361.2,326.7,361.2,331z M227.4,335.1 c44.9,0,89.5,0,134.2,0c0.8,3.9,1.5,7.8,2.4,11.9c-45.6,0-91,0-136.6,0C227.4,343.1,227.4,339.3,227.4,335.1z M361.5,314.1 c-44.7,0-89.3,0-134.1,0c0-4.3,0-8.5,0-12.6c45.6,0,91,0,136.8,0C362.9,305.8,362.4,309.9,361.5,314.1z M227.4,362.7 c0-3.7,0-7.4,0-11.5c46,0,91.9,0,138.1,0c1.4,3.5,2.9,7.2,4.5,11.5C322.3,362.7,275,362.7,227.4,362.7z M370.3,335.2 c2.5,0,4.8,0,7.3,0c0.6,3.9,1.6,7.6,2.7,11.6c-2.6,0-4.9,0-7.4,0C371.6,343.2,370.8,339.4,370.3,335.2z M374.3,351.1 c2.7-0.4,5.2-0.2,7.8-0.2c1.4,3.9,3.5,7.4,5.5,11.3c-2.8,0-5.4,0-8.1,0C377.5,358.8,375.8,355.2,374.3,351.1z M487.4,390.3 c-10,6.3-20.9,10.2-32.7,11.6c-34.9,3.9-62.6-17.7-72.5-35.6c2.9,0,5.5,0,8.1,0c14.5,18.5,33.2,28.8,56.9,28.6 c23.7-0.2,42.2-10.8,56.5-29.5c2.5,0,5.1,0,8.3,0C505.5,375.7,497.4,384,487.4,390.3z M514.5,361.2c-2.6,0-5.2,0-8.1,0 c1.8-3.6,3.7-6.9,5-10.5c2.5-0.3,4.9-0.2,7.6-0.1C517.9,354.4,516.2,357.7,514.5,361.2z M520.3,346.5c-2.4,0-4.7,0-7.3,0 c0.8-3.8,1.7-7.5,2.5-11.3c2.4-0.2,4.7-0.2,7.3,0C522.2,339.1,521.5,342.8,520.3,346.5z M523.2,331c-2.4,0.2-4.7,0.2-7.2,0 c0.2-4.2,0.3-8.3,0-12.6c2.7,0,4.9,0,7.3,0C523.8,322.7,523.6,326.8,523.2,331z", "M1124.9,346.1c-17.7,0.1-35.5-0.3-53.2-1c-0.8,0-1.7-0.1-2.7-0.1v7.8c19.6-2.1,38.9-5.2,58.8-5.7 C1126.7,346.1,1125.8,346.1,1124.9,346.1z", "M1170.3,286.6c-13,2.3-25.9,4.6-39,6.9c-0.5,3.1-3,3.3-5.4,3.3c-10.5,0.3-21,1.3-31.4,2.1c-8.5,0.6-16.9,2.1-25.4,2.3v10.9 c34.1-7.9,67.9-15.8,101.4-24.7C1170.4,287.2,1170.3,286.9,1170.3,286.6z", "M1124.3,293.4c-0.3-0.9-0.6-0.9-0.9-0.9c-17.3-0.7-34.6-1.4-51.9-2c-0.9,0-1.8,0-2.5-0.4v8.1c0,0.2,0.1,0.4,0.1,0.6 C1087.4,296.4,1105.8,294.9,1124.3,293.4z", "M1272.3,287.9c-1-1.5-1.3-2.9-1-4.7c0.5-2.3,0.7-4.7,0.7-7.1c-0.1-5.1-3-8.8-5.8-12.6c-4.4-6.3-7.5-13.1-7.1-21 c0.1-2.7-0.9-3.4-3.5-2.7c-9.5,2.5-19.2,4.3-28.8,6.4c-2.1,0.5-4.3,1.1-6.6,1.1c0-3.3,0-6.5,0-9.8c4.1-0.6,6.8-2.8,7.7-7 c0.3-1.6,0.5-3.3,0.5-5c-0.1-2.8-1.4-4.8-3.9-5.7c-6.7-2.4-13.4-2.3-20,0.1c-2.4,0.8-3.7,2.7-3.8,5.1c-0.2,5.8,1.2,11.3,7.8,12.4 c0.1,0,0.2,0.1,0.4,0.3c0,3.9,0,7.9,0,11.9c-11.3,2-22.4,4.2-33.9,5.4c0-2.1,0-3.9,0-5.7c0-1.8,0-3.6,0-5.2 c6.5-2.4,8.8-5.8,8.4-12.2c-0.2-2.9-1.5-4.9-4.3-5.8c-6.5-2.1-13-2-19.4,0.3c-1.9,0.7-3.2,1.9-3.7,3.9c-1.6,6.4,1.4,11.7,7.6,13.5 c0.1,0,0.2,0.2,0.3,0.2c0,4.2,0,8.4,0,12.7c-10.8,1.1-21.4,2.1-32.2,2c0-3.2,0-6.1,0-9.1c0.3-0.1,0.6-0.3,0.8-0.4 c5.8-1.8,9-8.3,6.9-14.1c-0.5-1.5-1.6-2.6-3.1-3.1c-6.9-2.6-13.9-2.6-20.8,0c-1.8,0.7-3,2-3.5,3.9c-1.5,6.4,1.6,11.7,7.9,13.5 c0.1,0,0.2,0.2,0.3,0.3c0,3.1,0,6.2,0,9.4c-0.7,0-1.3,0.2-1.8,0.1c-3-0.3-5.4,0.8-7.8,2.6c-11.7,8.4-24.3,14.6-38.8,16.3 c-1.4,0.2-2.5,1-2.7,2.5c0,0.1,0,0.1,0,0.2v5.9c0,0.2,0,0.4,0.1,0.7c17.3,0.8,34.4,1.5,51.7,2.3c-2.2-5.6-1.6-9.5,1.6-11.9 c3-2.3,6.7-2.4,9.7-0.3c2,1.5,3.2,3.5,3.4,6c0.2,2.4-0.4,4.6-2.4,6.9c11.1-2,21.4-3.8,31.9-5.6c-2.9-5.6-2.2-10.1,1.6-12.6 c3.5-2.2,8-1.5,10.6,1.7c3,3.8,2.3,8.2-2.4,12.8c11.7-3.2,22.8-6.3,34-9.4c-0.5-1.3-1.1-2.3-1.4-3.4c-1-3.6,0.4-7.4,3.5-9.3 c2.9-1.9,6.9-1.5,9.5,0.9c2.7,2.5,3.4,6.7,1.7,10c-1.6,3.2-5.1,4.9-8.7,4.1c-1-0.2-1.9,0-2.8,0.2c-16.1,4.4-32.1,8.9-48.2,13.2 c-27.4,7.3-55,14-82.7,20.1c-3.5,0.8-7,2.1-10.6,2.3v13.6c2.6,0.8,5.2,0.8,7.6,1.2c21.2,3.4,42.5,6.8,63.7,10.5 c23,4,45.8,8.5,68.6,13.6c2.3,0.5,4.6,0.8,7,1c3.4,0.2,6.2,3.3,6.9,6.9c0.7,3.8-0.8,7-4.1,8.8c-2.8,1.6-6.5,1.1-8.9-1 c-2.7-2.5-3.5-6.2-1.9-9.7c0.4-0.9,1-1.7,1.6-2.8c-5.8-1.2-11.4-2.4-17.1-3.6c-30.3-6.4-60.7-11.6-91.2-16.5 c-10.2-1.6-20.3-3.2-30.5-4.8c-0.6-0.1-1.3-0.2-1.7-0.6v10.1c0.7,0.5,1.3,0.4,1.8,0.4c18.3,0.2,36.5,1.1,54.8,0.8 c3.3,0,4.3,0.8,5.8,4c9.5,0.2,19,1.5,28.5,2.1c2.9,0.2,5.9-0.1,8,2.1c6.3-1.2,9.3,1.7,10.6,5.1c1.4,3.8-0.1,8.2-3.5,10.3 c-3.3,2-7.2,1.4-9.9-1.5c-2.9-3.1-2.8-7.2,0.4-11.8c-0.7-0.5-1.3-1-2.2-1.1c-10-0.3-19.9-1.5-29.9-2.3c-0.4,0-0.8,0-1.8,0 c2.8,2.3,4,4.8,3.8,8c-0.1,2.1-1.1,3.9-2.6,5.3c-3,2.9-7.5,3.1-10.6,0.4c-3.6-3.1-3.7-7.6-0.1-12.8c-1-0.8-2.1-0.7-3.3-0.6 c-16,1.8-32.1,3.5-48.1,5.6c-0.6,0.1-1.2,0.1-1.8,0.2v8.3c0.3,1.9,1.1,2.5,3.6,2.7c3,0.3,6,0.7,9,1.4c10.5,2.6,19.9,7.6,28.7,13.6 c2.7,1.8,5.3,3.1,8.6,2.7c0.7-0.1,1.4-0.2,2,0.3c0,3.3,0,6.7,0,9.9c-0.6,0.2-1,0.3-1.4,0.4c-5.4,1.8-8.5,8.4-6.4,13.8 c0.6,1.5,1.6,2.6,3.1,3.1c6.9,2.5,13.9,2.5,20.9,0c2-0.7,3.4-2.2,3.5-4.3c0.4-5.7-1-11.6-7.8-12.9c-0.2,0-0.3-0.2-0.5-0.3 c0-3.4,0-6.6,0-10c10.8-0.2,21.4,0.7,32,1.2c0.4,2.4,0.4,8.6-0.1,10.3c-6.1,2.1-8.2,5.3-8,12c0.1,2.7,1.3,4.7,3.8,5.6 c6.8,2.4,13.6,2.3,20.4-0.2c1.8-0.7,3.2-2,3.4-3.9c0.6-6.4-0.8-12.2-7.7-13.4c-0.1,0-0.2-0.2-0.3-0.3c0-3.1,0-6.2,0-9.5 c11.1,1.1,22.1,2.1,33,3.1c0,3.4,0,6.6,0,9.7c-1.3,0.5-2.5,0.7-3.6,1.3c-3.5,1.8-5.6,7.7-4.4,12.2c0.5,2,1.7,3.4,3.6,4 c6.7,2.3,13.4,2.2,20,0c2-0.7,3.3-2.1,3.8-4.1c1.5-6.1-1.6-11.5-7.6-13.3c-0.2-0.1-0.3-0.2-0.5-0.3c0-2.6,0-5.2,0-8 c12.8,1.5,25.4,3.8,37.6,5.5c1.3-1,1.3-1.9,1.3-2.9c0-2.3,0-4.6,0.4-6.9c1.3-6.3,4.5-11.7,8.3-16.8c3.9-5.1,5.4-10.7,4-17 c-0.5-2.2,0-4,1.3-5.9C1285.2,329,1284.8,305.7,1272.3,287.9z"];
    const BOUNDS=[{"y":150,"g":[[219,275]]},{"y":152,"g":[[210,287]]},{"y":154,"g":[[202,295]]},{"y":156,"g":[[196,303]]},{"y":158,"g":[[190,309]]},{"y":160,"g":[[185,315]]},{"y":162,"g":[[180,321]]},{"y":164,"g":[[176,327]]},{"y":166,"g":[[172,332]]},{"y":168,"g":[[169,337]]},{"y":170,"g":[[166,342]]},{"y":172,"g":[[163,347]]},{"y":174,"g":[[160,351]]},{"y":176,"g":[[157,356]]},{"y":178,"g":[[154,361]]},{"y":180,"g":[[152,365]]},{"y":182,"g":[[149,370]]},{"y":184,"g":[[147,374]]},{"y":186,"g":[[145,379]]},{"y":188,"g":[[143,383]]},{"y":190,"g":[[141,388]]},{"y":192,"g":[[139,392]]},{"y":194,"g":[[137,397]]},{"y":196,"g":[[135,401]]},{"y":198,"g":[[133,406]]},{"y":200,"g":[[131,410]]},{"y":202,"g":[[130,415]]},{"y":204,"g":[[128,420]]},{"y":206,"g":[[126,425]]},{"y":208,"g":[[125,429]]},{"y":210,"g":[[123,435]]},{"y":212,"g":[[122,440]]},{"y":214,"g":[[121,446]]},{"y":216,"g":[[119,451]]},{"y":218,"g":[[118,458]]},{"y":220,"g":[[116,464],[582,629]]},{"y":222,"g":[[115,472],[569,639]]},{"y":224,"g":[[114,481],[557,646]]},{"y":226,"g":[[113,491],[544,653]]},{"y":228,"g":[[112,658]]},{"y":230,"g":[[110,662]]},{"y":232,"g":[[109,666]]},{"y":234,"g":[[108,670]]},{"y":236,"g":[[107,673]]},{"y":238,"g":[[106,676]]},{"y":240,"g":[[105,678]]},{"y":242,"g":[[104,681]]},{"y":244,"g":[[103,683]]},{"y":246,"g":[[102,685]]},{"y":248,"g":[[101,687]]},{"y":250,"g":[[101,689]]},{"y":252,"g":[[100,691]]},{"y":254,"g":[[99,693]]},{"y":256,"g":[[98,695]]},{"y":258,"g":[[97,696]]},{"y":260,"g":[[96,698]]},{"y":262,"g":[[96,699]]},{"y":264,"g":[[95,701]]},{"y":266,"g":[[94,702]]},{"y":268,"g":[[93,703]]},{"y":270,"g":[[93,704]]},{"y":272,"g":[[92,706]]},{"y":274,"g":[[91,707]]},{"y":276,"g":[[91,262],[297,708]]},{"y":278,"g":[[90,256],[303,709]]},{"y":280,"g":[[89,254],[305,710]]},{"y":282,"g":[[89,252],[307,711]]},{"y":284,"g":[[88,251],[308,712]]},{"y":286,"g":[[88,250],[309,712]]},{"y":288,"g":[[87,249],[310,713]]},{"y":290,"g":[[87,249],[310,714]]},{"y":292,"g":[[86,249],[310,715]]},{"y":294,"g":[[85,249],[310,716]]},{"y":296,"g":[[85,249],[310,716]]},{"y":298,"g":[[84,249],[310,717]]},{"y":300,"g":[[84,249],[310,718]]},{"y":302,"g":[[83,249],[310,718]]},{"y":304,"g":[[83,249],[310,719]]},{"y":306,"g":[[83,249],[310,498],[537,719]]},{"y":308,"g":[[82,249],[310,489],[545,720]]},{"y":310,"g":[[82,249],[310,483],[551,721]]},{"y":312,"g":[[81,249],[310,478],[556,721]]},{"y":314,"g":[[81,249],[310,474],[561,722]]},{"y":316,"g":[[81,249],[310,470],[564,722]]},{"y":318,"g":[[80,249],[310,467],[568,722]]},{"y":320,"g":[[80,249],[310,464],[571,723]]},{"y":322,"g":[[79,249],[310,461],[574,723]]},{"y":324,"g":[[79,249],[310,458],[576,724]]},{"y":326,"g":[[79,249],[310,456],[579,724]]},{"y":328,"g":[[78,249],[310,454],[581,724]]},{"y":330,"g":[[78,249],[310,451]]},{"y":332,"g":[[78,249],[310,449]]},{"y":334,"g":[[77,249],[310,447]]},{"y":336,"g":[[77,249],[310,445]]},{"y":338,"g":[[77,249],[310,444]]},{"y":340,"g":[[77,249],[310,442]]},{"y":342,"g":[[76,249],[310,440]]},{"y":344,"g":[[76,249],[310,439]]},{"y":346,"g":[[76,249],[310,437]]},{"y":348,"g":[[76,249],[310,436]]},{"y":350,"g":[[75,249]]},{"y":352,"g":[[75,249]]},{"y":354,"g":[[75,249]]},{"y":356,"g":[[75,249]]},{"y":358,"g":[[74,249]]},{"y":360,"g":[[74,249]]},{"y":362,"g":[[74,249]]},{"y":364,"g":[[74,249]]},{"y":366,"g":[[74,249]]},{"y":368,"g":[[74,249]]},{"y":370,"g":[[74,249]]},{"y":372,"g":[[74,249]]},{"y":374,"g":[[74,249]]},{"y":376,"g":[[74,249]]},{"y":378,"g":[[74,249]]},{"y":380,"g":[[74,249]]},{"y":382,"g":[[74,249]]},{"y":384,"g":[[74,249]]},{"y":386,"g":[[74,249]]},{"y":388,"g":[[74,249]]},{"y":390,"g":[[74,249]]},{"y":392,"g":[[74,249]]},{"y":394,"g":[[74,249]]},{"y":396,"g":[[73,249]]},{"y":398,"g":[[73,249]]},{"y":400,"g":[[73,249]]},{"y":402,"g":[[73,249]]},{"y":404,"g":[[74,249]]},{"y":406,"g":[[74,249]]},{"y":408,"g":[[74,249]]},{"y":410,"g":[[74,249]]},{"y":412,"g":[[74,249]]},{"y":414,"g":[[74,249]]},{"y":416,"g":[[74,249]]},{"y":418,"g":[[74,249]]},{"y":420,"g":[[74,249]]},{"y":422,"g":[[74,249]]},{"y":424,"g":[[74,249]]},{"y":426,"g":[[74,249]]},{"y":428,"g":[[74,249]]},{"y":430,"g":[[74,249]]},{"y":432,"g":[[74,249]]},{"y":434,"g":[[74,249]]},{"y":436,"g":[[74,249]]},{"y":438,"g":[[74,249]]},{"y":440,"g":[[74,249]]},{"y":442,"g":[[75,249]]},{"y":444,"g":[[75,249]]},{"y":446,"g":[[75,249]]},{"y":448,"g":[[75,249]]},{"y":450,"g":[[76,249]]},{"y":452,"g":[[76,249]]},{"y":454,"g":[[76,249]]},{"y":456,"g":[[76,249]]},{"y":458,"g":[[77,249],[311,436]]},{"y":460,"g":[[77,249],[310,437]]},{"y":462,"g":[[77,249],[310,439]]},{"y":464,"g":[[78,249],[310,440]]},{"y":466,"g":[[78,249],[310,442]]},{"y":468,"g":[[78,249],[310,443]]},{"y":470,"g":[[79,249],[310,445]]},{"y":472,"g":[[79,249],[310,447]]},{"y":474,"g":[[79,249],[310,449]]},{"y":476,"g":[[80,249],[310,451]]},{"y":478,"g":[[80,249],[310,453],[581,723]]},{"y":480,"g":[[80,249],[310,455],[579,722]]},{"y":482,"g":[[81,249],[310,458],[576,722]]},{"y":484,"g":[[81,249],[310,460],[574,721]]},{"y":486,"g":[[82,249],[310,463],[571,721]]},{"y":488,"g":[[82,249],[310,466],[568,720]]},{"y":490,"g":[[82,249],[310,470],[565,720]]},{"y":492,"g":[[83,249],[310,473],[561,719]]},{"y":494,"g":[[83,249],[310,478],[557,719]]},{"y":496,"g":[[84,249],[310,483],[552,718]]},{"y":498,"g":[[84,249],[310,489],[546,717]]},{"y":500,"g":[[85,249],[310,497],[537,717]]},{"y":502,"g":[[85,249],[310,716]]},{"y":504,"g":[[86,249],[310,715]]},{"y":506,"g":[[86,249],[310,715]]},{"y":508,"g":[[87,249],[310,714]]},{"y":510,"g":[[87,249],[310,713]]},{"y":512,"g":[[88,249],[310,712]]},{"y":514,"g":[[88,249],[310,712]]},{"y":516,"g":[[89,249],[310,711]]},{"y":518,"g":[[89,249],[310,710]]},{"y":520,"g":[[90,250],[309,709]]},{"y":522,"g":[[91,251],[308,708]]},{"y":524,"g":[[91,252],[307,707]]},{"y":526,"g":[[92,254],[305,706]]},{"y":528,"g":[[93,256],[303,705]]},{"y":530,"g":[[93,262],[297,703]]},{"y":532,"g":[[94,702]]},{"y":534,"g":[[95,701]]},{"y":536,"g":[[96,699]]},{"y":538,"g":[[96,698]]},{"y":540,"g":[[97,696]]},{"y":542,"g":[[98,695]]},{"y":544,"g":[[99,693]]},{"y":546,"g":[[100,691]]},{"y":548,"g":[[101,689]]},{"y":550,"g":[[102,687]]},{"y":552,"g":[[102,685]]},{"y":554,"g":[[103,683]]},{"y":556,"g":[[104,681]]},{"y":558,"g":[[105,678]]},{"y":560,"g":[[106,676]]},{"y":562,"g":[[107,673]]},{"y":564,"g":[[108,669]]},{"y":566,"g":[[109,666]]},{"y":568,"g":[[111,661]]},{"y":570,"g":[[112,511],[522,657]]},{"y":572,"g":[[113,490],[544,651]]},{"y":574,"g":[[114,480],[557,645]]},{"y":576,"g":[[115,471],[569,638]]},{"y":578,"g":[[117,464],[582,629]]},{"y":580,"g":[[118,457]]},{"y":582,"g":[[119,451]]},{"y":584,"g":[[121,445]]},{"y":586,"g":[[122,440]]},{"y":588,"g":[[124,435]]},{"y":590,"g":[[125,429]]},{"y":592,"g":[[127,424]]},{"y":594,"g":[[128,419]]},{"y":596,"g":[[130,415]]},{"y":598,"g":[[131,410]]},{"y":600,"g":[[133,405]]},{"y":602,"g":[[135,401]]},{"y":604,"g":[[137,396]]},{"y":606,"g":[[139,392]]},{"y":608,"g":[[141,387]]},{"y":610,"g":[[143,383]]},{"y":612,"g":[[145,378]]},{"y":614,"g":[[147,374]]},{"y":616,"g":[[150,369]]},{"y":618,"g":[[152,365]]},{"y":620,"g":[[155,360]]},{"y":622,"g":[[157,356]]},{"y":624,"g":[[160,351]]},{"y":626,"g":[[163,346]]},{"y":628,"g":[[166,341]]},{"y":630,"g":[[170,336]]},{"y":632,"g":[[173,331]]},{"y":634,"g":[[177,326]]},{"y":636,"g":[[181,320]]},{"y":638,"g":[[186,315]]},{"y":640,"g":[[190,308]]},{"y":642,"g":[[196,302]]},{"y":644,"g":[[203,294]]},{"y":646,"g":[[211,286]]},{"y":648,"g":[[221,274]]}];

    // ═══════════════════════════════════════════════════
    // CONFIG
    // ═══════════════════════════════════════════════════
    const BODY_DY = -76; // shift body up to center with guitar detail
    const GUITAR_DX = 70; // shift ALL guitar paths right (single transform)
    const GUITAR_DY = 4; // shift guitar detail down
    const NECK_LEFT = 618; // 10 more in from left
    const NECK_RIGHT = 1123; // 15 more in from right
    const NECK_CY = 331; // true vertical center of the neck band
    const TITLE_DY = 0; // title is centered on NECK_CY

    // Guitar cut outline (red) — centered onto the composition
    const CUTLINE_D = "M1326.1,240.6c0.1-1.6,0.2-3.3,0.2-5l0-0.3c-0.2-11.6-6.1-19.5-9.5-24.2l-0.2-0.2c-3-4.3-3.3-6.5-3.2-7.8l0-0.2 c0.3-8.9-3.3-14.6-6.4-17.8c-4.3-4.5-10.1-6.9-16.5-6.9c-2.3,0-4.6,0.3-6.9,0.9c-0.5,0.1-1,0.3-1.5,0.4c-1.9-9.2-8.2-16.6-17.2-19.8 c-5.5-2-11.2-3-16.9-3c-5.8,0-11.6,1-17.1,3c-4,1.4-7.6,3.7-10.5,6.6c-0.5-0.2-1-0.4-1.6-0.6c-5.2-1.7-10.5-2.5-15.8-2.5 c-5.8,0-11.6,1-17.2,3l-0.2,0.1c-3.5,1.3-6.6,3.1-9.1,5.5c-5.7-2.1-11.5-3.2-17.4-3.2c-6,0-12,1.1-17.8,3.3l-0.2,0.1 c-8.1,3.1-14,9.8-16.2,18.2c0,0-0.1,0.4-0.1,0.5c-1.4,6-1.2,12.1,0.6,17.7c-7.9,4.8-15.3,7.5-22.9,8.4l-0.4,0.1 c-4.4,0.6-8.5,2.4-11.9,5.1l-2.6,0.5c-38.4,0-145-0.1-257.8-0.1l-120.1,0l-1.6-15.5c0-0.1,0-0.3-0.1-0.4 c-6.4-37.3-20-67.9-39.4-88.6c-19.6-20.8-41.8-32.1-74.2-37.7c-9.4-1.6-16.9-2.2-24.9-2.2c-12.6,0-26.3,1.6-52.3,6.2 c-17.3,2.9-20.3,3.3-33.1,3.3c-1.5,0-3.1,0-4.9,0c-17,0-19-0.3-28.7-2.2c-27.7-5.9-45-12.2-92.8-33.8c-64-28.9-89.4-37.6-123.5-42.1 c-7.6-1.1-20.8-1.2-26.2-1.2c-8.3,0-19.5,0.2-25.5,1.3c-40.5,7-68.8,20.9-94.7,46.6c-24,23.7-41.2,52.4-53.9,90.2 c-8.9,26.2-13.7,48.8-18.2,86.1c-2,15.8-2,78.3,0,95.6c3.9,32,10.3,62.4,18.2,85.7c15,44.1,37.6,78.4,67.1,101.9 c30.1,24.1,66.5,36.3,108,36.3c41.3,0,74-9.4,145.5-41.9c63.4-28.9,93.8-38.1,125.1-38.1c12.1,0,16.8,0.6,45.6,5.4 c19.7,3.4,25.7,4,42.6,4.1c21.2,0,31.6-1.6,50.4-7.7c20.7-6.7,34.4-15,48.7-29.8c17.5-17.9,28.9-39.6,36.7-70.3 c0.8-2.9,1.6-6.5,2.6-11.4c0-0.1,0-0.2,0.1-0.3l2.8-16.5l118.8,0c134,0,239.2-0.1,267-0.1c2.8,1.3,5.9,2.1,9.2,2.4 c2.6,0.3,4.5,0.5,6.1,0.9c5.2,1.3,10.5,3.6,16.3,7c-2.2,6.9-2,14.3,0.6,20.9l0.1,0.1c2.9,7.3,8.5,12.6,15.6,15.1 c5.7,2,11.5,3.1,17.4,3.1c5.9,0,11.8-1,17.4-3.1c1.1-0.4,2.1-0.8,3.1-1.3c1.8,1.2,3.7,2.1,5.8,2.9c5.5,1.9,11.2,2.9,16.9,2.9 c6,0,11.9-1.1,17.8-3.2l0.3-0.1c0.6-0.2,1.2-0.5,1.7-0.7c2.4,1.9,5.1,3.3,8,4.3c5.4,1.8,11,2.8,16.6,2.8c5.6,0,11.2-0.9,16.8-2.8 l0.3-0.1c8.7-3.1,15-9.9,17.3-18.9c0.1-0.4,0.2-0.8,0.3-1.2c2,0.3,4,0.6,5.9,0.9l5.8,0.8c0.3,0,0.6,0.1,1,0.1c1.5,0,3-0.5,4.3-1.5 l4.7-3.6c6.2-4.8,9.5-11.5,9.5-19.5c0-1.1,0-2.4,0.1-3.1c0.5-2.1,2-4.7,4.4-8c6.4-8.4,9.4-18.1,8.7-28.2 C1339.7,291.3,1339.5,263.4,1326.1,240.6z";
    const CUTLINE_DX = 35.2, CUTLINE_DY = 46.9;

    // Guitar extent in viewBox units (body left edge → headstock right edge)
    const CONTENT_W_U = 1275, CONTENT_H_U = 500;   // artwork only
    const OUTLINE_W_U = 1322, OUTLINE_H_U = 544;   // cut outline
    function guitarW(){ return state.outline ? OUTLINE_W_U : CONTENT_W_U; }
    function guitarH(){ return state.outline ? OUTLINE_H_U : CONTENT_H_U; }

    const LYRICS_FONTS = {
      serif:  '"Playfair Display", serif',
      sans:   '"Inter", sans-serif',
      slab:   '"Roboto Slab", serif',
      narrow: '"Oswald", sans-serif'
    };
    const LYRICS_FONT_FAMILIES = {
      serif:  'Playfair Display',
      sans:   'Inter',
      slab:   'Roboto Slab',
      narrow: 'Oswald'
    };

    let state = {
      title: '', lyrics: '',
      titleFont: 'Great Vibes', lyricsFont: 'serif',
      titleSize: 100, lyricsSize: 85,
      exportWidth: 12, unit: 'in', outline: false, repeat: true
    };

    // ═══════════════════════════════════════════════════
    // RENDER (preview — uses <text>, NO clip-path)
    // ═══════════════════════════════════════════════════
    const svgEl = document.getElementById('boardSvg');
    const NS = 'http://www.w3.org/2000/svg';

    function el(tag, attrs, parent) {
      const e = document.createElementNS(NS, tag);
      for (const [k, v] of Object.entries(attrs || {})) e.setAttribute(k, v);
      if (parent) parent.appendChild(e);
      return e;
    }

    // Store text metadata for export conversion
    let textMeta = [];

    function render() {
      svgEl.innerHTML = '';
      textMeta = [];

      // ── Guitar detail — ALL paths share ONE transform ──
      const guitarG = el('g', {
        id:'guitar-detail', fill:'#111', stroke:'none',
        transform:`translate(${GUITAR_DX},${GUITAR_DY})`
      }, svgEl);
      for (const d of GP) {
        el('path', { d }, guitarG);
      }

      // ── Title offset + title text ──
      // Instead of a rectangular backer, use a white stroke halo that follows letter contours
      const titleText2 = state.title.trim();
      // (gap measurement removed — the halo handles it naturally)

      // ── Lyrics text (placed within bounds, no clipping) ──
      const lyricsText = state.lyrics.trim();
      if (lyricsText) {
        const lyricsG = el('g', { id:'lyrics-text' }, svgEl);
        const baseFontSize = 10 * (state.lyricsSize / 100);
        const lineHeight = baseFontSize * 1.25;
        const font = LYRICS_FONTS[state.lyricsFont] || LYRICS_FONTS.serif;
        const charW = (state.lyricsFont === 'narrow') ? baseFontSize * 0.42
                   : (state.lyricsFont === 'sans')   ? baseFontSize * 0.52
                   : baseFontSize * 0.50;

        const words = lyricsText.replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase();
        const totalLen = words.length;
        let cursor = 0;

        const yMin = BOUNDS[0].y + BODY_DY;
        const yMax = BOUNDS[BOUNDS.length - 1].y + BODY_DY;

        for (let y = yMin; y <= yMax; y += lineHeight) {
          const lookupY = y - BODY_DY;
          let best = BOUNDS[0], bestDist = 9999;
          for (const b of BOUNDS) {
            const d = Math.abs(b.y - lookupY);
            if (d < bestDist) { bestDist = d; best = b; }
          }
          if (bestDist > lineHeight) continue;

          for (const [left, right] of best.g) {
            const w = right - left;
            if (w < 20) continue;

            const inset = 2; // small margin so text doesn't bleed past edges
            const usableW = w - inset * 2;
            const maxChars = Math.max(1, Math.floor(usableW / charW));

            // Stop entirely once the text is used up when repeat is off
            if (!state.repeat && cursor >= totalLen) continue;

            let line = '';
            for (let i = 0; i < maxChars; i++) {
              if (!state.repeat && cursor >= totalLen) break;
              line += words[cursor % totalLen];
              cursor++;
            }
            if (!line) continue;

            // Only stretch to fill when the line is actually full
            const isFullLine = line.length >= maxChars;

            const textY = y + baseFontSize * 0.8;
            const textX = left + inset;

            const attrs = {
              x: textX,
              y: textY,
              'font-family': font,
              'font-size': baseFontSize,
              fill: '#111'
            };
            if (isFullLine) {
              attrs['textLength'] = usableW;
              attrs['lengthAdjust'] = 'spacingAndGlyphs';
            }
            const t = el('text', attrs, lyricsG);
            t.textContent = line;

            textMeta.push({
              text: line, x: textX, y: textY,
              fontSize: baseFontSize, fontFamily: LYRICS_FONT_FAMILIES[state.lyricsFont],
              width: isFullLine ? usableW : null, type: 'lyrics'
            });
          }
        }
      }

      // ── Title text with offset gap ──
      const titleText = state.title.trim();
      if (titleText) {
        const fontFamily = `"${state.titleFont}", cursive`;
        const neckW = NECK_RIGHT - NECK_LEFT;
        const neckCX = (NECK_LEFT + NECK_RIGHT) / 2;
        const scale = state.titleSize / 100;
        const OFFSET_WIDTH = 14;

        const NECK_HEIGHT = 85; // max title height — string area (77) + small margin

        // Measure at reference size
        const refSize = 50;
        const tmp = el('text', {
          x: neckCX, y: 0,
          'text-anchor': 'middle',
          'font-family': fontFamily,
          'font-size': refSize,
          fill: 'none', opacity: 0
        }, svgEl);
        tmp.textContent = titleText;
        const bbox = tmp.getBBox();
        svgEl.removeChild(tmp);

        if (bbox.width > 0) {
          const fitWidth = refSize * (neckW / bbox.width); // size to fill width
          const fitHeight = refSize * (NECK_HEIGHT / bbox.height); // size to fill height
          const desired = Math.min(fitWidth, fitHeight) * scale; // slider adjusts
          const finalSize = Math.min(desired, fitWidth); // HARD CAP: never wider than neck

          // Invisible text to measure final bbox
          const measure = el('text', {
            x: neckCX, y: 0,
            'text-anchor': 'middle',
            'font-family': fontFamily,
            'font-size': finalSize,
            fill: 'none', opacity: 0
          }, svgEl);
          measure.textContent = titleText;
          const mBB = measure.getBBox();
          const finalY = -(mBB.y + mBB.height / 2) + NECK_CY + TITLE_DY;
          measure.setAttribute('y', finalY);
          const finalBB = measure.getBBox();
          svgEl.removeChild(measure);

          // White rect matched to text bbox + offset padding, rounded corners
          el('rect', {
            x: finalBB.x - OFFSET_WIDTH,
            y: finalBB.y - OFFSET_WIDTH,
            width: finalBB.width + OFFSET_WIDTH * 2,
            height: finalBB.height + OFFSET_WIDTH * 2,
            rx: OFFSET_WIDTH, ry: OFFSET_WIDTH,
            fill: '#ffffff', stroke: 'none'
          }, svgEl);

          // Title text on top
          const t = el('text', {
            x: neckCX, y: finalY,
            'text-anchor': 'middle',
            'font-family': fontFamily,
            'font-size': finalSize,
            fill: '#111', stroke: 'none'
          }, svgEl);
          t.textContent = titleText;

          textMeta.push({
            text: titleText,
            x: finalBB.x, y: finalY,
            fontSize: finalSize, fontFamily: state.titleFont,
            width: finalBB.width, height: finalBB.height, type: 'title', anchor: 'middle',
            centerX: neckCX, offsetWidth: OFFSET_WIDTH,
            bbox: { x: finalBB.x, y: finalBB.y, w: finalBB.width, h: finalBB.height }
          });
        }
      }

      // ── Red cut outline — drawn LAST so nothing covers it ──
      if (state.outline) {
        el('path', {
          d: CUTLINE_D,
          transform: `translate(${CUTLINE_DX},${CUTLINE_DY})`,
          fill: 'none', stroke: '#ff0000', 'stroke-width': '2'
        }, svgEl);
      }
    }

    // ═══════════════════════════════════════════════════
    // CONTROLS
    // ═══════════════════════════════════════════════════

    // Custom title font dropdown
    const fontDD = document.getElementById('titleFontDD');
    const fontTrigger = document.getElementById('titleFontTrigger');
    const fontLabel = document.getElementById('titleFontLabel');
    const fontMenu = document.getElementById('titleFontMenu');

    fontTrigger.addEventListener('click', () => fontDD.classList.toggle('open'));
    document.addEventListener('click', e => {
      if (!fontDD.contains(e.target)) fontDD.classList.remove('open');
    });
    fontMenu.addEventListener('click', e => {
      const item = e.target.closest('.font-dd-item');
      if (!item) return;
      fontMenu.querySelectorAll('.font-dd-item').forEach(i => i.classList.remove('on'));
      item.classList.add('on');
      state.titleFont = item.dataset.val;
      fontLabel.textContent = item.dataset.val;
      fontLabel.style.fontFamily = item.style.fontFamily;
      fontDD.classList.remove('open');
      render();
    });

    // Lyrics font segment buttons
    document.querySelectorAll('#lyricsFontSeg .sb').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('#lyricsFontSeg .sb').forEach(b => b.classList.remove('on'));
        btn.classList.add('on');
        state.lyricsFont = btn.dataset.val;
        render();
      });
    });

    // Sliders
    document.getElementById('titleSize').addEventListener('input', e => {
      state.titleSize = +e.target.value;
      document.getElementById('titleSizeVal').textContent = e.target.value + '%';
      render();
    });
    document.getElementById('lyricsSize').addEventListener('input', e => {
      state.lyricsSize = +e.target.value;
      document.getElementById('lyricsSizeVal').textContent = e.target.value + '%';
      render();
    });

    // Text inputs
    document.getElementById('titleInput').addEventListener('input', e => {
      state.title = e.target.value;
      render();
    });
    document.getElementById('lyricsInput').addEventListener('input', e => {
      state.lyrics = e.target.value;
      render();
    });

    // Width stepper
    const dimHint = document.getElementById('dimHint');
    const MM_PER_IN = 25.4;

    function widthStep()  { return state.unit === 'in' ? 0.5 : 10; }
    function widthMin()   { return state.unit === 'in' ? 2   : 50; }
    function widthMax()   { return state.unit === 'in' ? 48  : 1220; }
    function fmtWidth(v)  { return state.unit === 'in' ? (Math.round(v*2)/2).toFixed(1) : String(Math.round(v)); }

    function updateDim() {
      document.getElementById('widthVal').textContent = fmtWidth(state.exportWidth);
      const h = state.exportWidth * (guitarH() / guitarW());
      dimHint.textContent = `Guitar ≈ ${fmtWidth(state.exportWidth)} × ${state.unit==='in'?h.toFixed(1):Math.round(h)} ${state.unit}`;
    }

    document.getElementById('widthDec').addEventListener('click', () => {
      state.exportWidth = Math.max(widthMin(), state.exportWidth - widthStep());
      updateDim();
    });
    document.getElementById('widthInc').addEventListener('click', () => {
      state.exportWidth = Math.min(widthMax(), state.exportWidth + widthStep());
      updateDim();
    });

    // Unit switch — CONVERTS the current value
    function setUnit(u) {
      if (u === state.unit) return;
      state.exportWidth = (u === 'mm')
        ? state.exportWidth * MM_PER_IN
        : state.exportWidth / MM_PER_IN;
      state.unit = u;
      state.exportWidth = (u === 'in')
        ? Math.round(state.exportWidth * 2) / 2
        : Math.round(state.exportWidth);
      document.getElementById('unitIn').classList.toggle('on', u === 'in');
      document.getElementById('unitMm').classList.toggle('on', u === 'mm');
      updateDim();
    }
    document.getElementById('unitIn').addEventListener('click', () => setUnit('in'));
    document.getElementById('unitMm').addEventListener('click', () => setUnit('mm'));

    // Repeat lyrics checkbox
    document.getElementById('repeatChk').addEventListener('change', e => {
      state.repeat = e.target.checked;
      render();
    });

    // Guitar outline toggle
    document.querySelectorAll('#outlineSeg .sb').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('#outlineSeg .sb').forEach(b => b.classList.remove('on'));
        btn.classList.add('on');
        state.outline = btn.dataset.val === 'on';
        document.getElementById('outlineHint').style.display = state.outline ? '' : 'none';
        render();
      });
    });

    // Reset
    document.getElementById('resetBtn').addEventListener('click', () => {
      document.getElementById('titleInput').value = '';
      document.getElementById('lyricsInput').value = '';
      document.getElementById('titleSize').value = 100;
      document.getElementById('lyricsSize').value = 85;
      document.getElementById('titleSizeVal').textContent = '100%';
      document.getElementById('lyricsSizeVal').textContent = '85%';
        fontLabel.textContent = 'Great Vibes';
      fontLabel.style.fontFamily = "'Great Vibes', cursive";
      fontMenu.querySelectorAll('.font-dd-item').forEach((item, i) => item.classList.toggle('on', i === 0));
      state = { title:'', lyrics:'', titleFont:'Great Vibes', lyricsFont:'serif', titleSize:100, lyricsSize:85, exportWidth:12, unit:'in', outline:false, repeat:true };
      document.getElementById('repeatChk').checked = true;
      document.querySelectorAll('#outlineSeg .sb').forEach((b,i)=>b.classList.toggle('on', i===0));
      document.getElementById('outlineHint').style.display='none';
      document.getElementById('unitIn').classList.add('on');
      document.getElementById('unitMm').classList.remove('on');
      updateDim();
      document.querySelectorAll('#lyricsFontSeg .sb').forEach((b,i) => b.classList.toggle('on', i===0));
      render();
    });

    // ═══════════════════════════════════════════════════
    // DOWNLOAD — convert text to paths via opentype.js
    // ═══════════════════════════════════════════════════
    const dlBtn = document.getElementById('downloadBtn');
    const dlStatus = document.getElementById('dlStatus');
    const fontCache = {};

    // Direct TTF URLs from google/fonts repo — opentype.js can't read WOFF2
    const FONT_TTF = {
      'Great Vibes': 'https://raw.githubusercontent.com/google/fonts/main/ofl/greatvibes/GreatVibes-Regular.ttf',
      'Dancing Script': 'https://raw.githubusercontent.com/google/fonts/main/ofl/dancingscript/DancingScript%5Bwght%5D.ttf',
      'Parisienne': 'https://raw.githubusercontent.com/google/fonts/main/ofl/parisienne/Parisienne-Regular.ttf',
      'Sacramento': 'https://raw.githubusercontent.com/google/fonts/main/ofl/sacramento/Sacramento-Regular.ttf',
      'Pinyon Script': 'https://raw.githubusercontent.com/google/fonts/main/ofl/pinyonscript/PinyonScript-Regular.ttf',
      'Cormorant Garamond': 'https://raw.githubusercontent.com/google/fonts/main/ofl/cormorantgaramond/CormorantGaramond%5Bwght%5D.ttf',
      'Cinzel': 'https://raw.githubusercontent.com/google/fonts/main/ofl/cinzel/Cinzel%5Bwght%5D.ttf',
      'Alex Brush': 'https://raw.githubusercontent.com/google/fonts/main/ofl/alexbrush/AlexBrush-Regular.ttf',
      'Playfair Display': 'https://raw.githubusercontent.com/google/fonts/main/ofl/playfairdisplay/PlayfairDisplay%5Bwght%5D.ttf',
      'Inter': 'https://raw.githubusercontent.com/google/fonts/main/ofl/inter/Inter%5Bopsz%2Cwght%5D.ttf',
      'Roboto Slab': 'https://raw.githubusercontent.com/google/fonts/main/apache/robotoslab/RobotoSlab%5Bwght%5D.ttf',
      'Oswald': 'https://raw.githubusercontent.com/google/fonts/main/ofl/oswald/Oswald%5Bwght%5D.ttf',
    };

    async function getFont(family) {
      if (fontCache[family]) return fontCache[family];
      const url = FONT_TTF[family];
      if (!url) throw new Error('No TTF URL for: ' + family);
      dlStatus.textContent = `Loading font: ${family}…`;
      const resp = await fetch(url);
      if (!resp.ok) throw new Error(`Failed to fetch ${family}: ${resp.status}`);
      const buf = await resp.arrayBuffer();
      const font = opentype.parse(buf);
      fontCache[family] = font;
      return font;
    }

    // ═══════════════════════════════════════════════════
    // CLIPPER BOOLEAN OPS — following laser-cut best practices
    // ═══════════════════════════════════════════════════
    const CLIP_SCALE = 1000;

    function toCP(x,y){return{X:Math.round(x*CLIP_SCALE),Y:Math.round(y*CLIP_SCALE)};}

    // Fixed-step bezier flattening (fewer steps for small text, more for large)
    function flattenCubicSteps(pts,px,py,x1,y1,x2,y2,x,y,steps){
      steps=steps||7;
      for(let i=1;i<=steps;i++){
        const t=i/steps,u=1-t;
        pts.push(toCP(
          u*u*u*px+3*u*u*t*x1+3*u*t*t*x2+t*t*t*x,
          u*u*u*py+3*u*u*t*y1+3*u*t*t*y2+t*t*t*y
        ));
      }
    }
    function flattenQuadSteps(pts,px,py,x1,y1,x,y,steps){
      steps=steps||5;
      for(let i=1;i<=steps;i++){
        const t=i/steps,u=1-t;
        pts.push(toCP(u*u*px+2*u*t*x1+t*t*x, u*u*py+2*u*t*y1+t*t*y));
      }
    }

    // Convert opentype.js path to polygon rings
    function otPathToRings(otPath){
      const rings=[];let cur=[];let cx=0,cy=0;
      for(const c of otPath.commands){
        if(c.type==='M'){if(cur.length>=3)rings.push(cur);cur=[toCP(c.x,c.y)];cx=c.x;cy=c.y;}
        else if(c.type==='L'){cur.push(toCP(c.x,c.y));cx=c.x;cy=c.y;}
        else if(c.type==='C'){flattenCubicSteps(cur,cx,cy,c.x1,c.y1,c.x2,c.y2,c.x,c.y);cx=c.x;cy=c.y;}
        else if(c.type==='Q'){flattenQuadSteps(cur,cx,cy,c.x1,c.y1,c.x,c.y);cx=c.x;cy=c.y;}
        else if(c.type==='Z'){if(cur.length>=3)rings.push(cur);cur=[];}
      }
      if(cur.length>=3)rings.push(cur);
      return rings;
    }

    // Convert SVG path d string to polygon rings
    function svgDToRings(d){
      const rings=[];let cur=[];let cx=0,cy=0,sx=0,sy=0;
      const tks=d.match(/[MmLlHhVvCcSsQqZz]|[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/g)||[];
      let i=0;function n(){return parseFloat(tks[i++])||0;}
      while(i<tks.length){
        const cmd=tks[i];
        if(!/[A-Za-z]/.test(cmd)){i++;continue;}
        i++;
        if(cmd==='M'){cx=n();cy=n();sx=cx;sy=cy;if(cur.length>=3)rings.push(cur);cur=[toCP(cx,cy)];while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){cx=n();cy=n();cur.push(toCP(cx,cy));}}
        else if(cmd==='m'){cx+=n();cy+=n();sx=cx;sy=cy;if(cur.length>=3)rings.push(cur);cur=[toCP(cx,cy)];while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){cx+=n();cy+=n();cur.push(toCP(cx,cy));}}
        else if(cmd==='L'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){cx=n();cy=n();cur.push(toCP(cx,cy));}}
        else if(cmd==='l'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){cx+=n();cy+=n();cur.push(toCP(cx,cy));}}
        else if(cmd==='H'){cx=n();cur.push(toCP(cx,cy));}
        else if(cmd==='h'){cx+=n();cur.push(toCP(cx,cy));}
        else if(cmd==='V'){cy=n();cur.push(toCP(cx,cy));}
        else if(cmd==='v'){cy+=n();cur.push(toCP(cx,cy));}
        else if(cmd==='C'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){const x1=n(),y1=n(),x2=n(),y2=n(),x=n(),y=n();flattenCubicSteps(cur,cx,cy,x1,y1,x2,y2,x,y);cx=x;cy=y;}}
        else if(cmd==='c'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){const dx1=n(),dy1=n(),dx2=n(),dy2=n(),dx=n(),dy=n();flattenCubicSteps(cur,cx,cy,cx+dx1,cy+dy1,cx+dx2,cy+dy2,cx+dx,cy+dy);cx+=dx;cy+=dy;}}
        else if(cmd==='Q'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){const x1=n(),y1=n(),x=n(),y=n();flattenQuadSteps(cur,cx,cy,x1,y1,x,y);cx=x;cy=y;}}
        else if(cmd==='q'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){const dx1=n(),dy1=n(),dx=n(),dy=n();flattenQuadSteps(cur,cx,cy,cx+dx1,cy+dy1,cx+dx,cy+dy);cx+=dx;cy+=dy;}}
        else if(cmd==='S'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){const x2=n(),y2=n(),x=n(),y=n();flattenCubicSteps(cur,cx,cy,cx,cy,x2,y2,x,y);cx=x;cy=y;}}
        else if(cmd==='s'){while(i<tks.length&&!/[A-Za-z]/.test(tks[i])){const dx2=n(),dy2=n(),dx=n(),dy=n();flattenCubicSteps(cur,cx,cy,cx,cy,cx+dx2,cy+dy2,cx+dx,cy+dy);cx+=dx;cy+=dy;}}
        else if(cmd==='Z'||cmd==='z'){if(cur.length>=3)rings.push(cur);cur=[];cx=sx;cy=sy;}
      }
      if(cur.length>=3)rings.push(cur);
      return rings;
    }

    // Normalize polygons — just deduplicate, no SimplifyPolygons (causes DoMaxima)
    function cleanupPolygons(polys){
      const cleaned = [];
      for (const p of polys) {
        const deduped = [p[0]];
        for (let i = 1; i < p.length; i++) {
          if (p[i].X !== deduped[deduped.length-1].X || p[i].Y !== deduped[deduped.length-1].Y) {
            deduped.push(p[i]);
          }
        }
        if (deduped.length >= 3) cleaned.push(deduped);
      }
      return cleaned;
    }

    // Boolean UNION — minimal, no SimplifyPolygons
    function unionPolygons(polys){
      if(!polys.length)return[];
      const cleaned=cleanupPolygons(polys);
      if(!cleaned.length)return[];
      try {
        const cpr=new ClipperLib.Clipper();
        cpr.AddPaths(cleaned,ClipperLib.PolyType.ptSubject,true);
        const sol=new ClipperLib.Paths();
        cpr.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
        return sol.length ? sol : cleaned;
      } catch(e) { console.warn('Union fallback:', e.message); return cleaned; }
    }

    // Boolean DIFFERENCE — minimal
    function differencePolygons(subjPolys,clipPolys){
      const cleanSubj = cleanupPolygons(subjPolys);
      const cleanClip = cleanupPolygons(clipPolys);
      if(!cleanSubj.length) return [];
      if(!cleanClip.length) return cleanSubj;
      try {
        const cpr=new ClipperLib.Clipper();
        cpr.AddPaths(cleanSubj,ClipperLib.PolyType.ptSubject,true);
        cpr.AddPaths(cleanClip,ClipperLib.PolyType.ptClip,true);
        const sol=new ClipperLib.Paths();
        cpr.Execute(ClipperLib.ClipType.ctDifference,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
        return sol.length ? sol : cleanSubj;
      } catch(e) { console.warn('Diff fallback:', e.message); return cleanSubj; }
    }

    // Build rounded rect polygon
    function makeRoundedRect(x,y,w,h,r){
      r=Math.min(r||0,w/2,h/2);
      const pts=[];const steps=8;
      // Top-left corner
      for(let i=0;i<=steps;i++){const a=Math.PI+Math.PI/2*i/steps;pts.push(toCP(x+r+Math.cos(a)*r,y+r+Math.sin(a)*r));}
      // Top-right corner
      for(let i=0;i<=steps;i++){const a=Math.PI*1.5+Math.PI/2*i/steps;pts.push(toCP(x+w-r+Math.cos(a)*r,y+r+Math.sin(a)*r));}
      // Bottom-right corner
      for(let i=0;i<=steps;i++){const a=0+Math.PI/2*i/steps;pts.push(toCP(x+w-r+Math.cos(a)*r,y+h-r+Math.sin(a)*r));}
      // Bottom-left corner
      for(let i=0;i<=steps;i++){const a=Math.PI/2+Math.PI/2*i/steps;pts.push(toCP(x+r+Math.cos(a)*r,y+h-r+Math.sin(a)*r));}
      return pts;
    }

    // Convert Clipper polygons back to SVG path d
    function polysToSvgD(polys){
      let d='';
      for(const p of polys){
        if(p.length<3)continue;
        d+=`M${(p[0].X/CLIP_SCALE).toFixed(1)},${(p[0].Y/CLIP_SCALE).toFixed(1)}`;
        for(let i=1;i<p.length;i++)d+=`L${(p[i].X/CLIP_SCALE).toFixed(1)},${(p[i].Y/CLIP_SCALE).toFixed(1)}`;
        d+='Z ';
      }
      return d.trim();
    }

    // Convert text to UNIFIED polygon rings (handles overlapping script letters)
    function textToUnifiedPolygons(text, font, fontSize, x, y){
      if(!font||!text)return[];
      const path=font.getPath(text,x,y,fontSize);
      const rings=otPathToRings(path);
      if(rings.length>1){
        try{return unionPolygons(rings);}catch(e){return rings;}
      }
      return rings;
    }

    dlBtn.addEventListener('click', async () => {
      if (textMeta.length === 0 && GP.length === 0) return;

      dlBtn.disabled = true;
      dlStatus.textContent = 'Converting text to paths…';

      try {
        // Collect unique font families needed
        const families = [...new Set(textMeta.map(t => t.fontFamily))];
        const fonts = {};
        for (const fam of families) {
          fonts[fam] = await getFont(fam);
        }

        // Convert each text element to path data
        let lyricsPathD = '';
        let titlePathD = '';

        // Init paper.js on an offscreen canvas
        if (!paper.project) {
          const pcanvas = document.createElement('canvas');
          pcanvas.width = 2000; pcanvas.height = 1000;
          paper.setup(pcanvas);
        }

        const allLyricsD = [];
        const allTitleD = [];
        for (const tm of textMeta) {
          const font = fonts[tm.fontFamily];
          if (!font) continue;

          let x = tm.x;
          if (tm.anchor === 'middle') {
            const adv = font.getAdvanceWidth(tm.text, tm.fontSize);
            x = tm.centerX - adv / 2;
          }

          // Get opentype path
          const otPath = font.getPath(tm.text, x, tm.y, tm.fontSize);

          // Scale bezier curves for textLength stretch (before any conversion)
          if (tm.type === 'lyrics' && tm.width) {
            const naturalW = font.getAdvanceWidth(tm.text, tm.fontSize);
            if (naturalW > 0) {
              const scaleX = tm.width / naturalW;
              const ox = x;
              for (const cmd of otPath.commands) {
                if (cmd.x !== undefined) cmd.x = ox + (cmd.x - ox) * scaleX;
                if (cmd.x1 !== undefined) cmd.x1 = ox + (cmd.x1 - ox) * scaleX;
                if (cmd.x2 !== undefined) cmd.x2 = ox + (cmd.x2 - ox) * scaleX;
              }
            }
          }

          const rawD = otPath.toPathData(3);
          if (!rawD) continue;

          // paper.js boolean UNION — operates on bezier curves, outputs bezier curves
          let unitedD = rawD;
          try {
            const cp = new paper.CompoundPath(rawD);
            cp.fillRule = 'nonzero';
            // unite() with itself resolves all overlapping sub-paths into clean outlines
            const united = cp.unite(cp);
            unitedD = united.pathData || rawD;
            cp.remove();
            united.remove();
          } catch(e) { /* fallback to raw path */ }

          if (tm.type === 'lyrics') allLyricsD.push(unitedD);
          else allTitleD.push(unitedD);
        }

        dlStatus.textContent = 'Building SVG…';

        const tMeta = textMeta.find(t => t.type === 'title');
        // ── Physical size: the requested width applies to the GUITAR, not the canvas ──
        const vbParts = svgEl.getAttribute('viewBox').split(/[\s,]+/).map(Number);
        const vbX = vbParts[0], vbY = vbParts[1], vbW = vbParts[2];
        const LEGEND_H = 46;                        // room under the guitar for the legend
        const vbH = vbParts[3] + LEGEND_H;
        const unitsPerReq = state.exportWidth / guitarW();   // physical units per viewBox unit
        const w = (vbW * unitsPerReq).toFixed(3) + state.unit;
        const h = (vbH * unitsPerReq).toFixed(3) + state.unit;
        const vb = `${vbX} ${vbY} ${vbW} ${vbH}`;

        let outSvg = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        outSvg += `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${vb}" width="${w}" height="${h}">\n`;


        // ── Knock out backer from GP[0] strings using paper.js boolean subtract ──
        let gp0Out = GP[0];
        if (tMeta && tMeta.bbox) {
          const ow = tMeta.offsetWidth || 14;
          // Backer rect in GP[0]'s LOCAL coords (undo the group transform)
          const rx = tMeta.bbox.x - ow - GUITAR_DX;
          const ry = tMeta.bbox.y - ow - GUITAR_DY;
          const rw = tMeta.bbox.w + ow * 2;
          const rh = tMeta.bbox.h + ow * 2;
          try {
            const gp0Path = new paper.CompoundPath(GP[0]);
            gp0Path.fillRule = 'nonzero';
            const backer = new paper.Path.Rectangle({
              point: [rx, ry],
              size: [rw, rh],
              radius: ow
            });
            const knocked = gp0Path.subtract(backer);
            if (knocked && knocked.pathData) gp0Out = knocked.pathData;
            gp0Path.remove(); backer.remove(); knocked.remove();
          } catch(e) { console.warn('Knockout failed:', e.message); }
        }

        // Guitar detail — GP[0] with strings knocked out, rest unchanged
        outSvg += `  <g id="guitar-detail" fill="#111" stroke="none" transform="translate(${GUITAR_DX},${GUITAR_DY})">\n`;
        outSvg += `    <path d="${gp0Out}"/>\n`;
        for (let i = 1; i < GP.length; i++) {
          outSvg += `    <path d="${GP[i]}"/>\n`;
        }
        outSvg += `  </g>\n`;

        // Lyrics — one compound path, fill-rule nonzero prevents choppy overlaps
        if (allLyricsD.length) {
          outSvg += `  <path id="lyrics" fill="#111" fill-rule="nonzero" stroke="none" d="${allLyricsD.join(' ')}"/>\n`;
        }

        // Title — united via ClipperJS, one clean path
        if (allTitleD.length) {
          outSvg += `  <path id="title" fill="#111" fill-rule="nonzero" stroke="none" d="${allTitleD.join(' ')}"/>\n`;
        }

        // Red cut outline — LAST so nothing covers it
        if (state.outline) {
          outSvg += `  <path id="cut-outline" fill="none" stroke="#ff0000" stroke-width="1" transform="translate(${CUTLINE_DX},${CUTLINE_DY})" d="${CUTLINE_D}"/>\n`;
        }

        // Legend under the guitar
        const legendY = vbY + vbH - 14;
        outSvg += `  <g id="legend" font-family="Arial, Helvetica, sans-serif" font-size="15" font-weight="bold">\n`;
        outSvg += `    <text x="${vbX + 20}" y="${legendY}" fill="#ff0000">RED — CUT</text>\n`;
        outSvg += `    <text x="${vbX + 150}" y="${legendY}" fill="#111111">BLACK — ENGRAVE</text>\n`;
        outSvg += `  </g>\n`;

        outSvg += `</svg>`;

        // Download
        const blob = new Blob([outSvg], { type: 'image/svg+xml' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        const name = state.title ? state.title.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase() : 'guitar_lyrics';
        a.download = name + '.svg';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);

        dlStatus.textContent = 'Done — all text converted to paths ✓';
        setTimeout(() => { dlStatus.textContent = ''; }, 3000);

      } catch (err) {
        console.error(err);
        dlStatus.textContent = 'Error: ' + err.message;
      } finally {
        dlBtn.disabled = false;
      }
    });

    // ── Init ──
    render();
    updateDim();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuitarLyrics);
  } else {
    initGuitarLyrics();
  }
})();